import { combineReducers } from 'redux';

import logs from './logs';
import bootOption from './bootOption';
import posts from './posts';
import postsTimeline from './postsTimeline';
import postsTimelineStock from './postsTimelineStock';
import rank from './rank';
import rankAll from './rankAll';
import tuneCh from './tuneCh';
import digChs from './digChs';
import typingUsers from './typingUsers';

export const reducers = {
  bootOption,
  rank,
  rankAll,
  tuneCh,
  posts,
  postsTimeline,
  postsTimelineStock,
  digChs,
  typingUsers,
  logs,
};

export default combineReducers(reducers);
